var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRectangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    height: 106.14525139664804,
    viewBox: "0, 0, 400,106.14525139664804",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path0",
    d: "M0.000 46.000 L 0.000 92.000 4.792 91.995 C 8.741 91.990,9.640 91.946,9.907 91.745 C 10.191 91.530,33.381 91.500,199.839 91.500 C 383.318 91.500,389.457 91.490,389.724 91.195 C 389.979 90.913,390.000 88.010,390.001 52.820 C 390.002 19.375,390.032 14.692,390.251 14.273 C 390.460 13.872,390.500 12.692,390.500 6.898 L 390.500 0.000 195.250 0.000 L 0.000 0.000 0.000 46.000 ",
    stroke: "none",
    fill: "#0494d4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M390.163 14.428 C 390.059 14.701,390.000 28.584,390.000 52.902 C 390.000 89.549,389.989 90.958,389.695 91.224 C 389.412 91.480,375.983 91.500,199.816 91.500 C 28.505 91.500,10.205 91.525,9.870 91.759 L 9.500 92.019 9.500 99.009 L 9.500 106.000 204.750 106.000 L 400.000 106.000 400.000 60.000 L 400.000 14.000 395.163 14.000 L 390.325 14.000 390.163 14.428 ",
    stroke: "none",
    fill: "#046c9c",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle);
export default __webpack_public_path__ + "static/media/rectangle.77d5dc223c651e6a0e0cab70c7e6aa66.svg";
export { ForwardRef as ReactComponent };